import { wrapActions } from 'store/utils';

import * as actions from './actions';

export const useKpisActions = wrapActions({ ...actions });
